export default "__VITE_ASSET__CGqdOisT__"